import { yearConfig2025 } from '../v1/constants';
import { yearConfig2026 } from '../v2/constants';

/**
 * 年份配置接口
 */
export interface IYearConfig {
  USER_ROLE_CONFIG_MAP: Record<IQuarterReportUserRoleCode, IQuarterReportUserRoleConfig>;
  GENRE_ICON_MAP: IRecord<string>;
  ENTITY_TYPE_ICON_MAP: Record<IEntityType, string>;
}

// Re-export year configs for direct access if needed
export { yearConfig2025, yearConfig2026 };

/**
 * 根据年份获取对应的配置
 * @param year 年份数字（如 2025、2026）
 * @returns 对应年份的配置，未知年份默认返回 2026
 */
export const getYearConfig = (year: number): IYearConfig => {
  if (year <= 2025) return yearConfig2025;
  return yearConfig2026;
};

export const ENTITY_TYPE_CLASSNAME_MAP: IRecord<string> = {
  mobile: 'mobile',
  pc: 'pc',
  console: 'console',
  combine: 'combine',
};

export const ENTITY_TYPE_NAME_MAP: Record<IEntityType, string> = {
  mobile: 'dbu_common_mobile_game',
  pc: 'dbu_common_combine_game',
  console: 'dbu_common_combine_game',
  combine: 'dbu_common_combine_game',
};

export const GAME_DATA_GENE_GROUPS: [IQuarterReportGameDataGene, IQuarterReportGameDataGene][] = [
  ['E', 'I'],
  // ['S', 'N'],
  ['N', 'S'],
  ['T', 'F'],
  ['J', 'P'],
];

/**
 * 游戏数据基因配置映射
 */
export const GAME_DATA_GENE_CONFIG_MAP: Record<IQuarterReportGameDataGene, IQuarterReportGameDataGeneConfig> = {
  E: {
    code: 'E',
    name: 'dbu_quarter_report_game_data_gene_name_e',
    description: 'dbu_quarter_report_game_data_gene_description_e',
  },
  I: {
    code: 'I',
    name: 'dbu_quarter_report_game_data_gene_name_i',
    description: 'dbu_quarter_report_game_data_gene_description_i',
  },
  S: {
    code: 'S',
    name: 'dbu_quarter_report_game_data_gene_name_s',
    description: 'dbu_quarter_report_game_data_gene_description_s',
  },
  N: {
    code: 'N',
    name: 'dbu_quarter_report_game_data_gene_name_n',
    description: 'dbu_quarter_report_game_data_gene_description_n',
  },
  T: {
    code: 'T',
    name: 'dbu_quarter_report_game_data_gene_name_t',
    description: 'dbu_quarter_report_game_data_gene_description_t',
  },
  F: {
    code: 'F',
    name: 'dbu_quarter_report_game_data_gene_name_f',
    description: 'dbu_quarter_report_game_data_gene_description_f',
  },
  J: {
    code: 'J',
    name: 'dbu_quarter_report_game_data_gene_name_j',
    description: 'dbu_quarter_report_game_data_gene_description_j',
  },
  P: {
    code: 'P',
    name: 'dbu_quarter_report_game_data_gene_name_p',
    description: 'dbu_quarter_report_game_data_gene_description_p',
  },
};

export const GENRE_NAME_MAP: IRecord<string> = {
  ACTION: 'dbu_common_genre_action',
  ADVENTURE: 'dbu_common_genre_adventure',
  CASUAL: 'dbu_common_genre_casual',
  RPG: 'dbu_common_genre_rpg',
  RACING: 'dbu_common_genre_racing',
  SHOOTER: 'dbu_common_genre_shooter',
  SIMULATION: 'dbu_common_genre_simulation',
  SOFTWARE: 'dbu_common_genre_software',
  SPORTS: 'dbu_common_genre_sports',
  STRATEGY: 'dbu_common_genre_strategy',
};

/**
 * Fallback quarter configuration (used only if API fails)
 * 使用 YYYY-QN 作为 key，避免不同年份的同季度互相覆盖
 */
export const QUARTER_CONFIG_FALLBACK = {
  '2025-Q3': {
    quarter: 'Q3',
    startDate: '2025-07-01',
    endDate: '2025-09-30',
    label: '2025 Q3',
  },
  '2025-Q4': {
    quarter: 'Q4',
    startDate: '2025-10-01',
    endDate: '2025-12-31',
    label: '2025 Q4',
  },
  '2026-Q1': {
    quarter: 'Q1',
    startDate: '2026-01-01',
    endDate: '2026-03-31',
    label: '2026 Q1',
  },
  '2026-Q2': {
    quarter: 'Q2',
    startDate: '2026-04-01',
    endDate: '2026-06-30',
    label: '2026 Q2',
  },
} as const;

export const QUARTER_OPTIONS_FALLBACK: IQuarterOption[] = Object.values(QUARTER_CONFIG_FALLBACK).map((item) => ({
  quarter: item.quarter,
  date: item.startDate,
  available: true,
  label: item.label,
}));

export const DEFAULT_QUARTER_FALLBACK = QUARTER_OPTIONS_FALLBACK[QUARTER_OPTIONS_FALLBACK.length - 1]?.date || '';

